const CarePlanUpsellConfig = [{ span: 8, height: "179px", classes: "marginTop-16" }]

export default CarePlanUpsellConfig
